/*
 * Lemonade Training Oy copy rights all right reserved.
 * F032 step 7b: a coach's private note on one workout.
 *
 * Stored apart from the workout card (members can read cards):
 * `WorkoutNotes/{workoutID}`, no client rule, so Firestore's default deny
 * keeps every app out. Read and written only through the callables
 * getWorkoutNotes / saveWorkoutNote (functions/workoutNotes.js), gated like
 * the card writes (programmingAuthz assertCanManageProgramming).
 */

/** The stored document, `WorkoutNotes/{workoutID}`. */
export type WorkoutNoteDoc = {
  workoutID: string;
  programmingUID: string;
  /** 1..WORKOUT_NOTE_MAX characters; an empty note is deleted, never stored. */
  text: string;
  /** Server time of the last save. */
  updatedAt: unknown;
  /** uid of whoever saved it last. */
  updatedBy: string;
};

export type GetWorkoutNotesRequest = {
  programmingUID: string;
  /** Workouts of that programming, at most WORKOUT_NOTES_READ_CAP. */
  workoutIDs: string[];
};

/** Only workouts that have a note are present. */
export type GetWorkoutNotesResponse = {
  notes: Record<string, { text: string; updatedAtMs: number }>;
};

export type SaveWorkoutNoteRequest = {
  programmingUID: string;
  workoutID: string;
  /** Trimmed server-side; "" deletes the note. */
  text: string;
};

export type SaveWorkoutNoteResponse = { saved: boolean };

export const WORKOUT_NOTE_MAX = 2000;
export const WORKOUT_NOTES_READ_CAP = 100;
